export const GET_COURTS_SUCCESS = 'GET_COURTS_SUCCESS';
export const GET_ADDONSBYID_SUCCESS = 'GET_ADDONSBYID_SUCCESS';
export const GET_COURTS_ERROR = 'GET_COURTS_ERROR';
export const GET_COURTS_LOADING = 'GET_COURTS_LOADING';
export const GET_COURTS_LISTING_SUCCESS = 'GET_COURTS_LISTING_SUCCESS';
export const GET_LISTING_LOADING = 'GET_LISTING_LOADING';
